import { useState } from 'react';
import DefaultResetForm from '@/components/DefaultResetForm';
import { useUser } from '@/contexts/AuthContext';
import { phoneMask } from '@/utils/masks';
import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Button, Modal, Typography } from '@mui/material';
import { IModalSuccessData } from '.';

interface ResetPhone {
  onSuccess: (value?: IModalSuccessData) => void;
  handleClose: () => void;
}

const ResetPhone = ({ handleClose, onSuccess }: ResetPhone) => {
  const { user } = useUser();

  const [isOpenResetPhoneMessage, setIsOpenResetPhoneMessage] = useState(false);

  const handleSubmitResetPhone = async () => {
    setIsOpenResetPhoneMessage(true);
  };

  const confirmNewValidationPhone = () => {
    setIsOpenResetPhoneMessage(false);
    onSuccess();
  };
  return (
    <DefaultResetForm
      title="Verifique seu número"
      buttonText="alterar meu número de celular"
      onSubmit={handleSubmitResetPhone}
      handleCancel={handleClose}
      handleClose={handleClose}
      initialValues={{}}
    >
      <Box sx={{ opacity: '50%' }}>
        <Typography variant="caption">
          O número de celular vinculado à sua conta Obra Play:
        </Typography>
        <Typography
          variant="h5"
          data-testid="current-phone"
          sx={{
            marginTop: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            fontWeight: 700,
          }}
        >
          <PhoneIcon />
          {phoneMask(user?.phone || '')}
        </Typography>
      </Box>
      <Modal
        aria-labelledby="modal-reset-phone-message"
        aria-describedby="modal-reset-phone-message-description"
        open={isOpenResetPhoneMessage}
        sx={{ display: 'grid', placeItems: 'center' }}
      >
        <Box
          sx={{
            background: '#FFF',
            width: '382px',
            height: '163px',
            borderRadius: '4px',
            padding: '24px 0',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              opacity: '0.6',
              marginBottom: '36px',
              paddingX: '24px',
            }}
          >
            Para alterar o número de celular, será necessário fazer uma
            verificação com o novo número.
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => setIsOpenResetPhoneMessage(false)}>
              Cancelar
            </Button>
            <Button onClick={confirmNewValidationPhone}>Ok</Button>
          </Box>
        </Box>
      </Modal>
    </DefaultResetForm>
  );
};

export default ResetPhone;
